import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { RichiesteComponent } from './pages/richieste/richieste.component';
import { SchedeComponent } from './pages/schede/schede.component';
import { InterventiComponent } from './pages/interventi/interventi.component';
import { NuovoInterventoComponent } from './pages/interventi/nuovo-intervento/nuovo-intervento.component';
import { UtentiComponent } from './pages/configurazione/utenti/utenti.component';
import { FaqComponent } from './pages/configurazione/faq/faq.component';

export const routes: Routes = [
  {path: '', component: HomeComponent, pathMatch: 'full'},
  {path: 'richieste', component: RichiesteComponent},
  {path: 'schede', component: SchedeComponent},
  {path: 'interventi', component: InterventiComponent},
  {
    path: 'interventi/nuovo',
    component: NuovoInterventoComponent
  },
  {
    path: 'configurazione/utenti',
    component: UtentiComponent
  },
  {
    path: 'configurazione/faq',
    component: FaqComponent
  }
];
